



<div>
    <div class="row">
        <div class="col-sm-4">
            <p class="dataFecha" style="margin: 20px;">INSTITUCIÓN DONDE SE REALIZARÁ DENUNCIA</p>
        </div>
        <div class="col-sm-4">
            <p class="dataFecha" style="margin: 20px;">DIRECCIÓN</p>
        </div>
        <div class="col-sm-4">
            <p class="dataFecha" style="margin: 20px;">COMUNA O LOCALIDAD</p>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4">
            <p class="titulo" style="margin: 20px;">Ministerio Público</p>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="direccionMP" [(ngModel)]="institucionDenuncia.direccionMP" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="comunaLocalidadMP" [(ngModel)]="institucionDenuncia.comunaLocalidadMP" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4">
            <p class="titulo" style="margin: 20px;">Carabineros de Chile</p>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="direccionCarab" [(ngModel)]="institucionDenuncia.direccionCarab" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="comunaLocalidadCarab" [(ngModel)]="institucionDenuncia.comunaLocalidadCarab" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4">
            <p class="titulo" style="margin: 20px;">Policía de Investigaciones</p>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="direccionPDI" [(ngModel)]="institucionDenuncia.direccionPDI" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="comunaLocalidadPDI" [(ngModel)]="institucionDenuncia.comunaLocalidadPDI" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4">
            <p class="titulo" style="margin: 20px;">Tribunal de Competencia Penal</p>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="direccionTCP" [(ngModel)]="institucionDenuncia.direccionTCP" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="comunaLocalidadTCP" [(ngModel)]="institucionDenuncia.comunaLocalidadTCP" [disabled]="readonly" ></textarea>
        </div>
    </div>


</div>